export interface HouseholdLimit {
  householdSize: number;
  incomeLimit: number;
}

export enum LimitThreshold {
  Low = 'low',
  VeryLow = 'veryLow',
  ExtremelyLow = 'extremelyLow',
}
export interface Limits {
  [LimitThreshold.Low]: HouseholdLimit[];
  [LimitThreshold.VeryLow]: HouseholdLimit[];
  [LimitThreshold.ExtremelyLow]: HouseholdLimit[];
}

export interface IncomeLimit {
  id: string;
  fipsCode: string;
  year: number;
  refreshedAt: Date; // TODO does this work?
  limits: Limits;
}

export default IncomeLimit;
